__turbopack_context__.v({
  "collapseAllText": "CompareTable-module-scss-module__ctK1DG__collapseAllText",
  "compareTableWrapper": "CompareTable-module-scss-module__ctK1DG__compareTableWrapper",
  "itemDescription": "CompareTable-module-scss-module__ctK1DG__itemDescription",
  "itemDescriptionContainer": "CompareTable-module-scss-module__ctK1DG__itemDescriptionContainer",
  "itemDescriptionContainerEmpty": "CompareTable-module-scss-module__ctK1DG__itemDescriptionContainerEmpty",
  "noDataSpecsNamesStyles": "CompareTable-module-scss-module__ctK1DG__noDataSpecsNamesStyles",
  "sliderChangeButtonsContainer": "CompareTable-module-scss-module__ctK1DG__sliderChangeButtonsContainer",
  "specsNamesStyles": "CompareTable-module-scss-module__ctK1DG__specsNamesStyles",
  "specsPanelDataContainer": "CompareTable-module-scss-module__ctK1DG__specsPanelDataContainer",
  "tableCollapseContainer": "CompareTable-module-scss-module__ctK1DG__tableCollapseContainer",
  "tableHeaderContainer": "CompareTable-module-scss-module__ctK1DG__tableHeaderContainer",
  "tableHeaderExtra": "CompareTable-module-scss-module__ctK1DG__tableHeaderExtra",
  "tableSpecsText": "CompareTable-module-scss-module__ctK1DG__tableSpecsText",
  "tooltipInfoButton": "CompareTable-module-scss-module__ctK1DG__tooltipInfoButton",
  "upArrowButton": "CompareTable-module-scss-module__ctK1DG__upArrowButton",
});
